module.exports = __webpack_public_path__ + "media/images/stairs-a023817d05a2e7147f95ac7a340296e7.jpg";